import article1 from "../images/articles/1.jpg"
import article2 from "../images/articles/2.jpg"
import article3 from "../images/articles/3.jpg"
import article4 from "../images/articles/4.jpg"
import article5 from "../images/articles/5.jpg"
import article6 from "../images/articles/6.jpg"
import article7 from "../images/articles/7.jpg"

export const articlesData = [

  {
    id: '7-herasymchuk-faithful-message',
    titleKey: 'resourceArticle7Title',
    authorKey: 'resourceArticle7Author',
    descriptionKey: 'resourceArticle7ShortDesc',
    url: '/resources/7-faithful-message',
    img: article7,
    keywords_ua: [
      "в'ячеслав герасимчук", 'книга ісаї', 'ісая', 'надія', 'упование', 'рабшак', 'єзекія',
      'єрусалим', 'ассирія', 'сеннахирим', 'надія на бога', 'ісаія', 'пророк',
      'воєнний час', 'служіння', 'пасторська конференція', 'одеса', 'огляд ісаї',
      'месіанські обітниці', 'день господній', 'ізраїль', 'юдея', 'святість бога',
      'надія, яка не осоромлює', 'упование на христа', 'заповіт', 'вірність бога'
    ],
    keywords_en: [
      'vyacheslav herasymchuk', 'book of isaiah', 'isaiah', 'hope', 'trust', 'rabshakeh',
      'hezekiah', 'jerusalem', 'assyria', 'sennacherib', 'hope in god', 'prophet',
      'wartime ministry', 'pastoral conference', 'odesa', 'survey of isaiah',
      'messianic promises', 'day of the lord', 'israel', 'judah', 'holiness of god',
      'hope that does not put to shame', 'trust in christ', 'covenant', 'faithfulness of god'
    ]
  },

  {
    id: '6-zlatousty-on-the-priesthood',
    titleKey: 'resourceArticle6Title',
    authorKey: 'resourceArticle6Author',
    descriptionKey: 'resourceArticle6ShortDesc',
    url: '/resources/6-priesthood',
    img: article6,
    keywords_ua: ['Іоанн Золотоустий', 'проповідь', 'риторика', 'пасторське служіння', 'трактат Про священство', 'історія церкви', 'красномовство', 'С.В. Санніков'],
    keywords_en: ['John Chrysostom', 'preaching', 'rhetoric', 'pastoral ministry', 'treatise On the Priesthood', 'church history', 'eloquence', 'S.V. Sannikov']
  },

  {
    id: '5-mykola-leliovskyi-who-are-we-to-one-another',
    titleKey: 'resourceArticle5Title',
    authorKey: 'resourceArticle5Author',
    descriptionKey: 'resourceArticle5Description',
    url: '/resources/5-whoweare',
    img: article5,
    keywords_ua: [
      'микола леліовський', 'стосунки в церкві', 'церковна спільнота', 'християнська спільнота',
      'один одному', 'заповіді один одному', 'взаємини в церкві', 'любов у церкві',
      'смирення', 'церковна єдність', 'прощення', 'взаємне збудування',
      'примирення', 'біблійна етика', 'духовне зростання', 'здорова церква',
      'пастирська практика', 'міжособистісні взаємини', 'християнська етика', 'єдність церкви',
      'прощення в церкві', 'братолюбство', 'служіння один одному', 'християнська громада',
      'пастирська перспектива', 'новозавітні заповіді', 'любов до ближнього', 'християнська любов',
      'згуртованість', 'практичне богослов\'я'
    ],
    keywords_en: [
      'mykola leliovskyi', 'church relationships', 'church community', 'christian community',
      'one another', 'one another commandments', 'relationships in the church', 'love in the church',
      'humility', 'church unity', 'forgiveness', 'mutual edification',
      'reconciliation', 'biblical ethics', 'spiritual growth', 'healthy church',
      'pastoral practice', 'interpersonal relationships', 'christian ethics', 'unity of the church',
      'forgiveness in the church', 'brotherly love', 'serving one another', 'christian congregation',
      'pastoral perspective', 'new testament commandments', 'love for neighbor', 'christian love',
      'cohesiveness', 'practical theology'
    ]
  },

  {
    id: '4-resilience',
    titleKey: 'resourceArticle4Title',
    authorKey: '',
    descriptionKey: 'resourceArticle4Description',
    url: '/resources/4-resilience',
    img: article4,
    keywords_ua: [
      'подолання травми', 'від травми до стійкості', 'психологічна травма', 'стійкість',
      'зцілення серця', 'сергій санніков', 'джон стюард', 'семюел тільмен',
      'історія йосипа', 'псалми', 'книга псалмів', 'моральна травма',
      'душеопікунство', 'прощення і примирення', 'витривалість', 'терпеливість',
      'пошук сенсу', 'духовне зростання', 'молитва в скорботі', 'депресія та відчай',
      'емоційний біль', 'віра в бога', 'посттравматичне зростання', 'сльози та оплакування',
      'надія', 'безпека та небезпека', 'досвід страждань', 'біблійна перспектива',
      'пасторська перспектива', 'гіркий корінь'
    ],
    keywords_en: [
      'overcoming trauma', 'from trauma to resilience', 'psychological trauma', 'resilience',
      'healing of the heart', 'sergiy sannikov', 'john steward', 'samuel thielman',
      'story of joseph', 'psalms', 'book of psalms', 'moral injury',
      'pastoral care', 'forgiveness and reconciliation', 'endurance', 'patience',
      'finding meaning', 'spiritual growth', 'prayer in sorrow', 'depression and despair',
      'emotional pain', 'faith in god', 'post-traumatic growth', 'tears and mourning',
      'hope', 'safety and danger', 'experience of suffering', 'biblical perspective',
      'pastoral perspective', 'root of bitterness'
    ]
  },

  {
    id: 'viacheslav-herasymchuk-formation-of-hehemiah',
    titleKey: 'resourceArticle3Title',
    authorKey: 'resourceArticle3Author',
    descriptionKey: 'resourceArticle3Description',
    url: '/resources/nehemiah-formation',
    img: article3,
    keywords_ua: [
      'вячеслав герасимчук', 'неемія', 'становлення лідера', 'лідерство',
      'відновлення руїн', 'стіни єрусалиму', 'єрусалим', 'юдея', 'молитва',
      'піст та молитва', 'чашник', 'артаксеркс', 'реформатор', 'відбудова',
      'покаяння', 'заступництво', 'відповідальність', 'замуровник пролому',
      'заповіт', 'сузи', 'перська імперія', 'патріотизм', 'боже милосердя',
      'телеграфна молитва', 'експрес-молитва', 'духовна зрілість',
      'післяполонений період', 'намісник', 'боже покликання', 'організаційні здібності'
    ],
    keywords_en: [
      'vyacheslav herasymchuk', 'nehemiah', 'becoming a leader', 'leadership',
      'restoring ruins', 'walls of jerusalem', 'jerusalem', 'judea', 'prayer',
      'fasting and prayer', 'cupbearer', 'artaxerxes', 'reformer', 'rebuilding',
      'repentance', 'intercession', 'responsibility', 'repairer of the breach',
      'covenant', 'susa', 'persian empire', 'patriotism', 'god\'s mercy',
      'telegraph prayer', 'express prayer', 'spiritual maturity',
      'post-exilic period', 'governor', 'god\'s calling', 'organizational skills'
    ]
  },

  {
    id: 'miroslav-peiter-how-to-know-the-will-of-God',
    titleKey: 'resourceArticle2Title',
    authorKey: 'resourceArticle2Author',
    descriptionKey: 'resourceArticle2Description',
    url: '/resources/the-gods-will',
    img: article2,
    keywords_ua: [
      'мирослав пейтер', 'божа воля', 'воля божа', 'пізнати волю бога', 'покликання',
      'служіння', 'духовні дари', 'таланти', 'призначення', 'християнське служіння',
      'що в тебе в руці', 'жезл мойсея', 'друге поприще', 'максимум зусиль',
      'святе засмучення', 'пристрасне бажання', 'сенс життя', 'мета життя',
      'дари святого духа', 'духовна харизма', 'духовна праця', 'вірність у малому',
      'вільям бут', 'армія спасіння', 'тематична проповідь', 'посвята',
      'благословення', 'духовне зростання', 'місія', 'християнське життя'
    ],
    keywords_en: [
      'miroslav peiter', 'god\'s will', 'will of god', 'knowing god\'s will', 'calling',
      'ministry', 'spiritual gifts', 'talents', 'purpose', 'christian service',
      'what is in your hand', 'rod of moses', 'second mile', 'maximum effort',
      'holy frustration', 'passionate desire', 'meaning of life', 'life goal',
      'gifts of the holy spirit', 'spiritual charisma', 'spiritual work',
      'faithful in little', 'william booth', 'salvation army', 'topical sermon',
      'dedication', 'blessing', 'spiritual growth', 'mission', 'christian life'
    ]
  },

  {
    id: 'bondarenko-pastoral-vocation',
    titleKey: 'resourceArticle1Title',
    authorKey: 'resourceArticle1Author',
    descriptionKey: 'resourceArticle1Description',
    url: '/resources/pastoral-vocation',
    img: article1,
    keywords_ua: [
      'пастор', 'пастир', 'пресвітер', 'єпископ', 'служитель',
      'пасторське покликання', 'покликання до служіння', 'рукопокладення',
      'висвячення', 'помісна церква', 'громада', 'община',
      'дари святого духа', 'духовні дарування', 'самозванці',
      'найманці', 'обрання пастора', 'пасторське служіння',
      'духовна зрілість', 'християнське керівництво', 'проповідь слова',
      'мотиви служіння', 'вимоги до пресвітера', 'воля божа',
      'благочестя', 'розсудливість', 'авторитет пастора', 'діотрефство',
      'гордість', 'марнославство', 'відповідальність служителя',
      'пастирське богослов\'я', 'анатолій бондаренко'
    ],
    keywords_en: [
      'pastor', 'shepherd', 'presbyter', 'elder', 'bishop', 'minister',
      'pastoral vocation', 'pastoral calling', 'calling to ministry',
      'ordination', 'local church', 'congregation', 'gifts of the holy spirit',
      'spiritual gifts', 'impostors', 'hirelings', 'pastoral election',
      'pastoral ministry', 'spiritual maturity', 'christian leadership',
      'preaching the word', 'motives for ministry', 'requirements for an elder',
      'will of god', 'godliness', 'prudence', 'pastoral authority',
      'diotrephesism', 'pride', 'vanity', 'minister\'s responsibility',
      'pastoral theology', 'anatoliy bondarenko'
    ]
  }
];
